import React from 'react';
import { Stack, TextField, Typography } from "@mui/material";


export default function ParticipantDummy() {
    return (
        <Stack spacing={2}>
            <Typography>pepep</Typography>
            <TextField label='maxinquepa' />
            <TextField label='pepe' />
            <TextField label='xiulxi' />
        </Stack>
    );
}